export default function HomeTemplate({ page, renderSections }) {
  return <div>{renderSections()}</div>;
}

HomeTemplate.displayName = 'HomeTemplate';
